import { css } from 'lit';
export enum Breakpoint {
	PHONE = '0px',
	PHONE_XL = '576px',
	TABLET = '768px',
	DESKTOP = '1080px',
	DESKTOP_XL = '1400px',
	DESKTOP_ULTRAWIDE = '2000px',
}
